<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Colors" pageTitle="Colors" />
            <ColorsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ColorsContent from '../Colors/ColorsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ColorsPage',
    components: {
        MainHeader,
        PageTitle,
        ColorsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>